import { LOGO, BRAND } from "@/data/content";
import { Facebook } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "About", id: "about" },
  { label: "Gallery", id: "gallery" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-ink border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
          <button onClick={() => scrollToId("home")} aria-label="Back to top">
            <img src={LOGO} alt="MOTO LUXE" className="h-24 w-auto" />
          </button>

          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`footer-link-${l.id}`}
                onClick={() => scrollToId(l.id)}
                className="font-mono text-[11px] tracking-[0.2em] uppercase text-cream/60 hover:text-gold transition-colors"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="text-left lg:text-right">
            <a
              href={BRAND.phoneHref}
              className="block font-serif text-2xl text-cream hover:text-gold transition-colors"
            >
              {BRAND.phone}
            </a>
            <span className="font-mono text-[11px] tracking-[0.2em] text-gold/70">
              {BRAND.website}
            </span>
            <div className="mt-4 flex lg:justify-end">
              <a
                data-testid="footer-facebook"
                href={BRAND.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="MOTO LUXE on Facebook"
                className="inline-flex items-center justify-center h-10 w-10 rounded-full border border-gold/40 text-gold hover:bg-gold hover:text-ink transition-all duration-300"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="divider-gold my-10" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono text-[10px] tracking-[0.15em] text-cream/40 uppercase">
            © {new Date().getFullYear()} MOTO LUXE — Motorcycle Detailing. New Zealand.
          </p>
          <p className="font-mono text-[10px] tracking-[0.15em] text-cream/30 uppercase">
            Black · Gold · Gloss · Precision
          </p>
        </div>
      </div>
    </footer>
  );
}
